import { CoffeeLibrary } from "./components/coffee-library"
import { DashboardInsights } from "./components/dashboard-insights"

export const registry = {
  CoffeeLibrary,
  DashboardInsights,
}
